import { ListApiResponse, SuccessApiResponse } from '@ianesthesie-kit/services';
import { Invoice } from '@/modules/billing/billing.model';
import axios, { AxiosResponse } from 'axios';

export class BillingService {
  private static INSTANCE = new BillingService();

  private readonly url: string;

  private constructor() {
    this.url = `/bff/patient/billing/invoice`;
  }

  public static getInstance(): BillingService {
    return this.INSTANCE;
  }

  public fetchAll(): Promise<ListApiResponse<Invoice>> {
    return axios
      .get(this.url)
      .then(
        (response: AxiosResponse<ListApiResponse<Invoice>>) => response.data
      );
  }

  public sign(invoice: Invoice): Promise<SuccessApiResponse> {
    return axios
      .post(`${this.url}/${invoice.id}/sign`)
      .then((response: AxiosResponse<SuccessApiResponse>) => response.data);
  }
}
